import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { BsArrowRepeat } from "react-icons/bs";

const ResetEmailModal = ({
  visible,
  close,
  referee,
  user,
  onReset,
  loading = false
}) => {
  return (
    <Modal show={visible} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title className="text-capitalize">
          <h1 className="text-axis-offblack icon-text-wrapper">
            <BsArrowRepeat className="icon-right-spacing" />
            Reset Email Address
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>New Email Address</Form.Label>
            <Form.Control
              type="email"
              defaultValue={referee?.refereeEmail || ""}
              placeholder="Enter new email address"
              disabled={loading}
              id="resetEmailInput"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={close}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={() => {
            const email = document.getElementById('resetEmailInput').value;
            onReset(email);
          }}
          disabled={loading}
        >
          {loading ? "Resetting..." : "Reset Email"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetEmailModal;